import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import "../styles/brands.css";
import { Checkbox, Radio } from "antd";
import axios from "axios";
import { Price } from "../pages/Price";
import { ColorRing } from "react-loader-spinner";
import { server } from "../server";
import notFound from "../images/notFound.png";
import CarCard from "./CarCard";

const CarSearch = () => {
  const [cars, setcars] = useState([]);
  const [brand, setBrand] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedPriceRange, setSelectedPriceRange] = useState(null);
  const [search, setsearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search");

  const getAllBrand = async () => {
    try {
      const { data } = await axios.get(`${server}/api/brand/getAll-brand`);
      if (data.success) {
        setBrand(data.brands);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(true);
    }
  };

  const getAllcars = async () => {
    try {
      const data = await fetch(
        `${server}/api/car/getAll-car?searchQuery=${searchQuery}`,
        {
          method: "GET",
          headers: { "Content-type": "application/json" },
        }
      );
      const data_ = await data.json();
      setcars(data_?.cars?.reverse());
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(true);
    }
  };

  const handleBrandChange = (e, brandId) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedBrands((prevSelectedBrands) => [
        ...prevSelectedBrands,
        brandId,
      ]);
    } else {
      setSelectedBrands((prevSelectedBrands) =>
        prevSelectedBrands.filter((id) => id !== brandId)
      );
    }
  };

  const handlePriceChange = (e) => {
    const priceRange = e.target.value;
    setSelectedPriceRange(priceRange);
  };

  const resetFilters = () => {
    setSelectedBrands([]);
    setSelectedPriceRange(null);
    setsearch("");
  };

  useEffect(() => {
    getAllBrand();
    getAllcars();
    window.scrollTo(0, 0);
    //eslint-disable-next-line
  }, []);

  console.log("cars", cars);

  return (
    <>
      <div className="brand_wrapper" id="cars" style={{ marginTop: "60px" }}>
        <div className="col-12 text-center">
          <p className="brand_subtitle">Click me to see all vehicles </p>
          <h2 className="brand_title">Search results for: {searchQuery}</h2>
        </div>
      </div>
      <div className="container">
        <div
          className="row"
          style={{ marginBottom: "100px", marginTop: "-50px" }}
        >
          <div className="col-md-12 col-lg-3">
            <h4 className=" mt-4">Filter By Brands</h4>
            <div className="d-flex flex-column">
              {brand?.map((c) => (
                <Checkbox
                  key={c._id}
                  onChange={(e) => handleBrandChange(e, c._id)}
                  checked={selectedBrands.includes(c._id)}
                >
                  {c.name}
                </Checkbox>
              ))}
            </div>
            <h4 className=" mt-4">Filter By Price Range</h4>
            <div className="d-flex flex-column">
              <Radio.Group
                onChange={handlePriceChange}
                value={selectedPriceRange}
              >
                {Price.map((p) => (
                  <div key={p._id}>
                    <Radio value={p.array}>{p.name}</Radio>
                  </div>
                ))}
              </Radio.Group>
            </div>
            <div className="d-flex flex-column">
              <button
                className="btn btn-outline-dark my-4"
                onClick={resetFilters}
              >
                RESET FILTERS
              </button>
            </div>
          </div>
          <div className="col-md-12 col-lg-9">
            {loading ? (
              <div className="h-100 d-flex align-items-center justify-content-center">
                <ColorRing
                  visible={true}
                  colors={[
                    "#000435",
                    "rgb(14 165 233)",
                    "rgb(243 244 246)",
                    "#000435",
                    "rgb(14 165 233)",
                  ]}
                />
              </div>
            ) : cars.length === 0 ? (
              <div className="text-center">
                <div className="text-center marginStyle">
                  <img src={notFound} width={200} alt="NOT FOUND" />
                  <h1>
                    <span
                      className="text-danger fs-1"
                      style={{ fontSize: "16px" }}
                    >
                      not found
                    </span>
                    <br />{" "}
                    <Link
                      to="/login"
                      style={{ textDecoration: "none" }}
                      className="nav-item text-center"
                    >
                      {/* eslint-disable-next-line */}
                      <a
                        className="nav-link learn-more-btn btn-extra-header"
                        aria-current="page"
                      >
                        cars
                      </a>
                    </Link>
                  </h1>
                </div>
              </div>
            ) : (
              <div className="row">
                {cars
                  .filter((car) => {
                    return search.toString().toLowerCase() === ""
                      ? car
                      : car.name.toLowerCase().includes(search);
                  })
                  .filter(
                    (car) =>
                      selectedBrands.length === 0 ||
                      selectedBrands.includes(car.brand._id)
                  )
                  .filter((car) => {
                    if (!selectedPriceRange) return true;
                    const [minPrice, maxPrice] = selectedPriceRange;
                    return car.price >= minPrice && car.price <= maxPrice;
                  })
                  .map((p) => (
                    <div className="col-md-12 col-lg-4 mb-3" key={p._id}>
                      <CarCard p={p} />
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CarSearch;
